// extracted by mini-css-extract-plugin
export default {"container":"notFound_container__HgDEQ","title":"notFound_title__WRefO","description":"notFound_description__rbxIo","back":"notFound_back__CT5gv"};